import React from "react"
import { Tile, Heading, IconHeading, SlideUpText, SlideUpTextContent } from "./style"
import { Icon } from "components/UI"
import parse from "html-react-parser"

const Highlight = ({ tile: { content, heading, icon }}) => {
  return (
    <Tile>
      <IconHeading>
        <Icon
          name={icon}
          width={["58px", "87px"]} 
          height={["58px", "87px"]} 
        />
        <Heading>{parse(heading)}</Heading>
      </IconHeading>
      <SlideUpText>
        <SlideUpTextContent>
          {parse(content)}
        </SlideUpTextContent>
      </SlideUpText>
    </Tile>
  )
}

export default Highlight
